export abstract class Transform {
  abstract apply(block: any): any;
}
